import React from "react"

import KnowledgeModerationButtons from "../../../common/knowledge-list/KnowledgeModerationButtons"
import ViewFormActionButtonsWidget from "../../../common/ViewFormActionButtonsWidget"
import FeedRejectionReasonModalContainer from "../FeedRejectionReasonModalContainer"

const ViewFeedFormActionButtonsWidget = props => {
    const {
        canEdit,
        moderationStatus,
        suggestedModerationStatus,
        approve,
        reject,
        unmoderate,
        isSaving,
        isRejectReasonModalOpen
    } = props

    return (
        <ViewFormActionButtonsWidget {...props}>
            <KnowledgeModerationButtons
                {...{
                    canSave: canEdit,
                    isSaving,
                    moderationStatus,
                    approve,
                    reject,
                    unmoderate,
                    suggestedModerationStatus
                }}
            />
            {isRejectReasonModalOpen && (
                <FeedRejectionReasonModalContainer
                    isOpen={isRejectReasonModalOpen}
                />
            )}
        </ViewFormActionButtonsWidget>
    )
}

export default ViewFeedFormActionButtonsWidget
